/**
 * Safe in-app path after login (blocks open redirects).
 * Paths must start with `${PUBLIC_URL}/${jobseeker|recruiter}/`.
 */
export function getSafePostLoginRedirect(raw, loginTypeUpper) {
  if (!raw || typeof raw !== "string") return null;
  try {
    const decoded = decodeURIComponent(raw.trim());
    if (decoded.includes("..") || /[\0\r\n]/.test(decoded)) return null;
    if (/^\w[\w+.-]*:/.test(decoded)) return null;
    let path = decoded.startsWith("/") ? decoded : `/${decoded}`;
    const base = process.env.PUBLIC_URL || "/job";
    const seg =
      String(loginTypeUpper || "JOBSEEKER").toUpperCase() === "RECRUITER"
        ? "recruiter"
        : "jobseeker";
    const prefix = `${base}/${seg}/`;
    if (!path.startsWith(prefix)) return null;
    return path;
  } catch (e) {
    return null;
  }
}
